import { UserAvatarGroup, UserAvatarGroupProps } from './UserAvatarGroup'
import { useUsersValue } from './User'

export interface UserGroupRendererProps extends Omit<UserAvatarGroupProps, 'users'> {
  /**
   * Comma-separate string of user ids.
   */
  value?: string
}

export const UserGroupRenderer: React.FC<UserGroupRendererProps> = ({ value, ...props }) => {
  const users = useUsersValue(value)

  return <UserAvatarGroup users={users} {...props} />
}
